import { Store } from '@sama/app-state';
import { assert, isDefined } from '@sama/js-core';

export function assertStore<T>(
  store: Store<T | undefined>,
  message: string,
): asserts store is Store<T> {
  assert(isDefined(store.state()), message);
}

export function getOrThrowStore<
  KeyType extends string | number | symbol,
  ValueType,
>(stores: Store<StrictRecord<KeyType, ValueType>>, key: KeyType) {
  const store = stores(key);
  assertStoreKeyValue<KeyType, ValueType>(store, key);
  return store;
}

function assertStoreKeyValue<
  KeyType extends string | number | symbol,
  ValueType,
>(
  store: Store<ValueType | undefined>,
  key: KeyType,
): asserts store is Store<ValueType> {
  assertStore(store, `store for key ${key.toString()} should be defined`);
}
